import styled from 'styled-components';

import { colors, media, type } from 'styles';

export const CTAWrapper = styled.div`
  width: 100%;
  margin-top: 8px;

  ${media.min.baseline`margin-top: 20px;`}
`;

export const Heading = styled.h1`
  font-weight: ${type.weight.bold};
  font-size: 2.2rem;
  margin-top: 28px;

  ${media.min.baseline`
    font-size: 2.4rem;
    margin-top: 32px;
  `}

  ${media.min.desktop`
    font-size: 2.8rem;
    margin-top: 40px;
  `}
`;

export const LegalText = styled.div`
  text-align: center;
  font-size: ${type.scale.centi.size};
  font-weight: ${type.weight.regular};
  color: ${colors.ridge.base};
  margin-top: 14px;
  line-height: normal;
  padding: 0 28px;
`;
